{
  "seo": {
    "title": "Pricing — Free & Family Plans",
    "description": "CuriPop is free to explore! Upgrade to the Family plan for unlimited questions, quizzes, and subscriber printables.",
    "keywords": "curipop pricing, kids learning app price, educational app free, family plan"
  },
  "recovery": {
    "title": "We could not renew your subscription payment.",
    "subtitle": "Your access is currently limited. Update your payment method to restore full access.",
    "action": "Fix Payment Method",
    "opening": "Opening..."
  },
  "hero": {
    "tagline": "Start free, upgrade anytime!",
    "titlePrefix": "Simple Pricing for",
    "titleHighlight": "Curious Families",
    "subtitle": "One plan. Unlimited discovery. All your kids, one price."
  },
  "billing": {
    "monthly": "Monthly",
    "annual": "Annual",
    "switchToMonthly": "Switch to monthly billing",
    "switchToAnnual": "Switch to annual billing",
    "save": "Save $10"
  },
  "plans": {
    "popularBadge": "Most Popular",
    "spacer": "Spacer",
    "placeholder": "placeholder",
    "free": {
      "name": "Free Explorer",
      "tagline": "Perfect for trying Curipop",
      "period": "forever",
      "priceLabel": "Free",
      "noCard": "No credit card required",
      "cta": "Start Free",
      "included": "What's included:",
      "features": [
        "12 questions per day (rotating daily selection)",
        "Full answers on the daily set",
        "Badges & favorites",
        "Parent dashboard & child profiles",
        "Ad-free experience"
      ],
      "limits": [
        "Limited to 12 questions daily",
        "No quiz modes",
        "Subscriber printables not included"
      ]
    },
    "family": {
      "name": "Family",
      "tagline": "Best for curious families",
      "period": "month",
      "billingAnnual": "Billed annually ($49.99/year)",
      "billingMonthly": "Billed monthly",
      "savings": "Save 17%",
      "priceSeparator": "/{period}",
      "originalPrice": "${price}/month",
      "cta": "Start Free",
      "included": "Everything in Free, plus:",
      "features": [
        "Unlimited questions",
        "Unlimited quizzes (easy, normal, hard)",
        "Subscriber printables (when available)",
        "Everything in Free Explorer"
      ]
    }
  },
  "trust": {
    "items": [
      {
        "label": "7-day free trial",
        "sublabel": "on Family plan"
      },
      {
        "label": "No credit card",
        "sublabel": "to start free"
      },
      {
        "label": "Cancel anytime",
        "sublabel": "no questions asked"
      }
    ]
  },
  "benefits": {
    "titlePrefix": "Why Families Choose",
    "titleHighlight": "Curipop",
    "subtitle": "One simple subscription for the whole family",
    "items": [
      {
        "title": "Unlimited Curiosity",
        "description": "No limits on questions. Kids can explore as much as they want!"
      },
      {
        "title": "Family Profiles",
        "description": "Keep multiple child profiles with their own progress and favorites."
      },
      {
        "title": "Unlimited Quizzes",
        "description": "Unlock easy, normal, and hard quiz modes for deeper practice."
      },
      {
        "title": "Subscriber Printables",
        "description": "Download subscriber printables as they are published."
      },
      {
        "title": "Parent Peace of Mind",
        "description": "Ad-free, COPPA compliant, with a dedicated parent dashboard."
      },
      {
        "title": "Growing Library",
        "description": "New questions are added regularly across all topics."
      }
    ]
  },
  "comparison": {
    "title": "Compare Plans",
    "headers": {
      "feature": "Feature",
      "free": "Free",
      "family": "Family",
      "recommended": "Recommended"
    },
    "unavailable": "—",
    "rows": [
      {
        "name": "Question access",
        "free": "12/day (rotating)",
        "family": "Unlimited"
      },
      {
        "name": "Quiz modes",
        "free": "",
        "family": ""
      },
      {
        "name": "Printables library",
        "free": "Free printables when available",
        "family": "Subscriber printables when available"
      },
      {
        "name": "Badges & favorites",
        "free": "",
        "family": ""
      },
      {
        "name": "Parent dashboard",
        "free": "",
        "family": ""
      },
      {
        "name": "Child profiles",
        "free": "Multiple",
        "family": "Multiple"
      }
    ]
  },
  "schools": {
    "tagline": "For Educators",
    "title": "Schools & Classrooms",
    "subtitle": "Special pricing for schools with class codes, printables, and privacy-first access. COPPA & FERPA compliant.",
    "primary": "Get School Pricing",
    "secondary": "Learn More"
  },
  "faq": {
    "title": "Common Questions",
    "items": [
      {
        "q": "Can I try Curipop before paying?",
        "a": "Yes! Our Free plan gives you 12 questions every day from our curated discovery set — the selection rotates daily, forever free. Want unlimited access? Start a 7-day free trial of the Family plan."
      },
      {
        "q": "How many kids can use one Family plan?",
        "a": "You can add multiple child profiles under one Family plan, each with their own progress and favorites."
      },
      {
        "q": "Can I cancel anytime?",
        "a": "Absolutely. Cancel anytime from your account settings. You'll keep access until the end of your billing period. No cancellation fees, ever."
      },
      {
        "q": "Is there a discount for annual billing?",
        "a": "Yes! Pay annually and save $10/year — that's like getting 2 months free compared to monthly billing."
      },
      {
        "q": "Do you offer school or classroom pricing?",
        "a": "Yes! We offer special pricing for schools, including class codes and printables. Contact school@curipop.com for details."
      },
      {
        "q": "Is my child's data safe?",
        "a": "Absolutely. We're COPPA compliant, meaning we follow strict rules to protect children's privacy. We don't sell data, show ads, or share information with third parties."
      }
    ]
  },
  "finalCta": {
    "title": "Start Your Child's Discovery Journey",
    "subtitle": "Try free today. No credit card needed. Cancel anytime.",
    "primary": "Start Free",
    "secondary": "Preview Content"
  }
}
